import { TabList as MuiTabList, TabListProps as MuiTabListProps } from "@mui/lab";
import { Tab as MuiTab, Stack, SxProps, Theme } from "@mui/material";
import { tabListSxMap, tabSxMap } from "../config";
import { TabListTab, TabsVariant } from "../types";

interface TabListProps {
  tabs: TabListTab[];
  onChange: (tabId: string) => void;
  variant?: TabsVariant;
  tabListProps?: Omit<MuiTabListProps, "children" | "onChange">;
}

const TabList = ({ tabs, onChange, variant = "standard", tabListProps }: TabListProps) => {
  const { sx: tabListSx, ...restTabListProps } = tabListProps || {};
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    onChange(newValue);
  };

  return (
    <MuiTabList
      {...restTabListProps}
      onChange={handleChange}
      sx={{ minHeight: 36, ...tabListSxMap[variant], ...tabListSx } as SxProps<Theme>}>
      {tabs.map((tab) => (
        <MuiTab
          key={tab.id}
          label={
            <Stack
              spacing={1}
              direction='row'
              useFlexGap>
              {tab.startIcon}
              {tab.title}
            </Stack>
          }
          value={tab.id}
          disableRipple
          disabled={tab.disabled}
          sx={{ minHeight: 36, ...tabSxMap[variant] }}
        />
      ))}
    </MuiTabList>
  );
};

export default TabList;
